import React from "react";
import './style.css'


const JobDetail = () => {
      return (
        <div>
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          {/* font style css link */}
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
          {/* fontawesome link */}
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossOrigin="anonymous" referrerPolicy="no-referrer" />
          {/* bootstrap css link */}
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous" />
          {/* custom css link */}
          <link rel="stylesheet" href="./style.css" />
          <title>BetterJobPlacement</title>
         
         
          <section id="job-details-section">
            {/* hero section beginning*/}
            <div className="hero">
              <div className="job-info-section d-flex">
                <div className="job-brief-detail d-flex">
                  <span className="job-logo">
                    <img src="https://superio-appdir.vercel.app/_next/image?url=%2Fimages%2Fresource%2Fcompany-logo%2F1-1.png&w=128&q=75" alt="job logo" srcSet />
                  </span>
                  <div>
                    <h4>Software Engineer (Android), Libraries</h4>
                    <ul className="job-brief-info d-flex">
                      <li><span className="fa-solid fa-briefcase" />Segment</li>
                      <li><span className="fa-solid fa-location-dot" />London, UK</li>
                      <li><span className="fa-regular fa-clock" />11 hours ago</li>
                      <li><span className="fa-solid fa-money-bill-1-wave" />₹35k - ₹50k</li>
                    </ul>
                    <ul className="job-other-info d-flex">
                      <li className="time">Full Time</li>
                      <li className="privacy">Private</li>
                      <li className="required">Urgent</li>
                    </ul>
                  </div>
                </div>
                <div className="apply-button-section d-flex">
                  <div className="apply-button">
                    <a href="https://api.whatsapp.com/send?phone=9895898507&forceIntent=true&load=loadInIOSExternalSafari">Apply For Job</a>
                  </div>
                  {/* <div className="save-btn" /> */}
                </div>
              </div>
            </div>
            {/* hero section end */}
            {/* job description beginnig */}
            <div className="job-description-portion">
              <div className="row1 d-flex">
                <div className="content-container col-lg-7 col-md-12 col-sm-12">
                  <div className="job-description">
                    <h4>Job Description</h4>
                    <p className="job-small-description">As a Product Designer, you will work within a Product Delivery Team fused with UX, engineering, product and data talent. You will help the team design beautiful interfaces that solve business challenges for our clients. We work with a number of Tier 1 banks on building web-based applications for AML, KYC and Sanctions List management workflows. This role is ideal if you are looking to segue your career into the FinTech or Big Data arenas.</p>
                    <h4>key Responsiblities</h4>
                    <ul className="list-style">
                      <li>Be involved in every step of the product design cycle from discovery to developer handoff and user acceptance testing.</li>
                      <li>Work with BAs, product managers and tech teams to lead the Product Design</li>
                      <li>Maintain quality of the design process and ensure that when designs are translated into code they accurately reflect the design specifications.</li>
                      <li>Accurately estimate design tickets during planning sessions</li>
                      <li>Contribute to sketching sessions involving non-designersCreate, iterate and maintain UI deliverables including sketch files, style guides, high fidelity prototypes, micro interaction specifications and pattern libraries.</li>
                      <li>Ensure design choices are data led by identifying assumptions to test each sprint, and work with the analysts in your team to plan moderated usability test sessions.</li>
                      <li>Design pixel perfect responsive UI’s and understand that adopting common interface patterns is better for UX than reinventing the wheel</li>
                      <li>Present your work to the wider business at Show &amp; Tell sessions.</li>
                    </ul>
                    <h4 className="skill">Skill &amp; Experience</h4>
                    <ul className="list-style">
                      <li>You have at least 3 years’ experience working as a Product Designer.</li>
                      <li>You have experience using Sketch and InVision or Framer X</li>
                      <li>You have some previous experience working in an agile environment – Think two-week sprints.</li>
                      <li>You are familiar using Jira and Confluence in your workflow</li>
                    </ul>
                  </div>
                  {/* <div className="share-options-portion">
                    <div className="share-options d-flex">
                      <h5>Share this job</h5>
                      <a href="#/" target="_blank" className="facebook"><i className="fa-brands fa-facebook-f" />Facebook</a>
                      <a href="#/" target="_blank" className="twitter"><i className="fa-brands fa-twitter" />Twitter</a>
                      <a href="#/" target="_blank" className="linkedin"><i className="fa-brands fa-linkedin-in" />Linkedin</a>
                    </div>
                  </div> */}
                  <div className="related-jobs-portion">
                    <div className="title-box">
                      <h3>Related Jobs</h3>
                      <div className="text">2020 jobs live - 293 added today.</div>
                    </div>
                    <div className="job-box">
                      <div className="inner-box">
                        <div className="content">
                          <span className="company-logo"><img src="https://superio-appdir.vercel.app/_next/image?url=%2Fimages%2Fresource%2Fcompany-logo%2F1-4.png&w=64&q=75" alt="company logo" srcSet /></span>
                          <h4><a href="#/" target="_blank" rel="noopener noreferrer">Senior Product Designer</a></h4>
                          <ul className="job-brief-info d-flex">
                            <li><span className="fa-solid fa-briefcase" />Upwork</li>
                            <li><span className="fa-solid fa-location-dot" />London, UK</li>
                            <li><span className="fa-regular fa-clock" />11 hours ago</li>
                            <li><span className="fa-solid fa-money-bill-1-wave" />₹35k - ₹45k</li>
                          </ul>
                          <ul className="job-other-info d-flex">
                            <li className="time">Full Time</li>
                            <li className="privacy">Private</li>
                            <li className="required">Urgent</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="job-box">
                      <div className="inner-box">
                        <div className="content">
                          <span className="company-logo"><img src="https://superio-appdir.vercel.app/_next/image?url=%2Fimages%2Fresource%2Fcompany-logo%2F1-5.png&w=64&q=75" alt="company logo" srcSet /></span>
                          <h4><a href="#/" target="_blank" rel="noopener noreferrer">Senior Product Designer</a></h4>
                          <ul className="job-brief-info d-flex">
                            <li><span className="fa-solid fa-briefcase" />Medium</li>
                            <li><span className="fa-solid fa-location-dot" />London, UK</li>
                            <li><span className="fa-regular fa-clock" />11 hours ago</li>
                            <li><span className="fa-solid fa-money-bill-1-wave" />₹35k - ₹45k</li>
                          </ul>
                          <ul className="job-other-info d-flex">
                            <li className="time">Full Time</li>
                            <li className="privacy">Private</li>
                            <li className="required">Urgent</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="job-box">
                      <div className="inner-box">
                        <div className="content">
                          <span className="company-logo"><img src="https://superio-appdir.vercel.app/_next/image?url=%2Fimages%2Fresource%2Fcompany-logo%2F1-6.png&w=64&q=75" alt="company logo" srcSet /></span>
                          <h4><a href="#/" target="_blank" rel="noopener noreferrer">Senior Product Designer</a></h4>
                          <ul className="job-brief-info d-flex">
                            <li><span className="fa-solid fa-briefcase" />Figma</li>
                            <li><span className="fa-solid fa-location-dot" />London, UK</li>
                            <li><span className="fa-regular fa-clock" />11 hours ago</li>
                            <li><span className="fa-solid fa-money-bill-1-wave" />₹35k - ₹45k</li>
                          </ul>
                          <ul className="job-other-info d-flex">
                            <li className="time">Full Time</li>
                            <li className="privacy">Private</li>
                            <li className="required">Urgent</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sidebar-portion  col-lg-4 col-md-12 col-sm-12">    
                  <aside className="sidebar">
                    <div className="sidebar-job-overview">
                      <h4 className="widget-title">Job Overview</h4>
                      <div className="widget-content">
                        <ul className="job-overview">
                          <li>
                            <i className="icon fa-solid fa-briefcase" />
                            <h5>Date Posted:</h5>
                            <span>Posted 1 hours ago</span>
                          </li>
                          <li>
                            <i className="icon fa-regular fa-hourglass" />
                            <h5>Expiration date:</h5>
                            <span>April 06, 2021</span>
                          </li>
                          <li>
                            <i className="icon fa-solid fa-location-dot" />
                            <h5>Location:</h5>
                            <span>London, UK</span>
                          </li>
                          <li>
                            <i className="icon fa-regular fa-user" />
                            <h5>Job Title:</h5>
                            <span>Designer</span>
                          </li>
                          <li>
                            <i className="icon fa-regular fa-clock" />
                            <h5>Hours:</h5>
                            <span>50h / week</span>
                          </li>
                          <li>
                            <i className="icon fa-solid fa-coins" />
                            <h5>Rate:</h5>
                            <span>$15 - $25 / hour</span>
                          </li>
                          <li>
                            <i className="icon fa-solid fa-money-bill-1-wave" />
                            <h5>Salary:</h5>
                            <span>$35k - $45k</span>
                          </li>
                        </ul>
                      </div>
                      <h4 className="widget-title skill-needed">Job Skills</h4>
                      <div className="widget-content">
                        <ul className="job-skills d-flex">
                          <li><a href="#/">app</a></li>
                          <li><a href="#/">administrative</a></li>
                          <li><a href="#/">android</a></li>
                          <li><a href="#/">wordpress</a></li>
                          <li><a href="#/">design</a></li>
                          <li><a href="#/">react</a></li>
                        </ul>
                      </div>
                    </div>
                    <div className="sidebar-job-overview company-widget">
                      <div className="widget-content">
                        <div className="company-title">
                          <div className="company-logo">
                            <img src="https://superio-appdir.vercel.app/_next/image?url=%2Fimages%2Fresource%2Fcompany-logo%2F1-1.png&w=64&q=75" alt="" srcSet />
                          </div>
                          <h5 className="company-name">Segment</h5>
                          <a href="#/" className="profile-link">View company profile</a>
                        </div>
                        <ul className="company-info">
                          <li>Primary industry: <span>Software</span></li>
                          <li>Company size: <span>501-1,000</span></li>
                          <li>Founded in: <span>2011</span></li>
                          <li>Phone: <span>123 456 7890</span></li>
                          <li>Email: <span>info@joio.com</span></li>
                          <li>Location: <span>London, UK</span></li>
                          <li>Social media: <div className="social-links">
                              <a href="#/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f" /></a>
                              <a href="#/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-twitter" /></a>
                              <a href="#/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram" /></a>
                              <a href="#/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in" /></a>
                            </div></li>
                        </ul>
                        <div className="btn-box d-flex">
                          <a href="#/" target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-three">https://segment.com</a>
                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
              </div>
            </div>
            {/* job description end */}
          </section>
          {/* job detail section end */}
          <footer id="footer">
            <div className="footer-content d-flex">
              <div className="contact-section">
                <div className="logo-section d-flex">
                  <div className="company-logo-detail">
                    {/* <a href="#/"><img src="/images/logo.png" alt="" srcset=""></a> */}
                  </div>
                  <div className="company-name-detail">
                    <h5>Better Job Placement</h5>
                  </div>
                </div>
                <div className="number-section">
                  <h5>Call us</h5>
                  <p><a href="#/"><i className="phone fa-solid fa-phone-volume" />9895898502</a><br />
                    <a href="#/"><i className="whatsapp fa-brands fa-whatsapp" />9895898507</a></p>
                </div>
                <p className="address">
                  NAZ MALL, KARAKKUNNU JN<br />
                  MANJERI<br />
                  <a href="#/" className="email">betterplacementmanjeri@gmail.com</a>
                </p>
              </div>
              <div className="link-section d-flex">
                <div className="candidate-section">
                  <h4 className="widget-title">For Candidates</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Browse Jobs</a></li>
                      <li><a href="#/">Browse Categories</a></li>
                      <li><a href="#/">Candidate Dashboard</a></li>
                      <li><a href="#/">Job Alerts</a></li>
                      <li><a href="#/">My Bookmarks</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">For Employers</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Browse Candidates</a></li>
                      <li><a href="#/">Employer Dashboard</a></li>
                      <li><a href="#/">Add Job</a></li>
                      <li><a href="#/">Job Packages</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">About Us</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">About Us</a></li>
                      <li><a href="#/">Job Page Invoice</a></li>
                      <li><a href="#/">Terms Page</a></li>
                      <li><a href="#/">Blog</a></li>
                      <li><a href="#/">Contact</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">Helpful Resources</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Site Map</a></li>   
                      <li><a href="#/">Terms of Use</a></li>
                      <li><a href="#/">Privacy Center</a></li>
                      <li><a href="#/">Security Center</a></li>
                      <li><a href="#/">Accessibility Center</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="footer-bottom">
              <div className="copyright-wrap">
                Copyright© 2024 Future Consultancy Ltd. All Rights Reserved.
              </div>
            </div> */}
          </footer>
        </div>
      );
    }

    export default JobDetail